module.exports = __webpack_public_path__ + "media/components/country-flag/static/lb-e484b8550f710b51fe801bf548fcbd93.svg";